export default __webpack_public_path__ + "static/assets/cf1a440e311b216957026353c3adefe2.svg";